import { Controller } from "@hotwired/stimulus"

// 용도 선택에서 '기타' 선택 시 텍스트 입력 표시
export default class extends Controller {
  static targets = ["selectInput", "customField", "customInput"]

  connect() {
    this.toggle()
  }

  toggle() {
    const value = this.selectInputTarget.value
    const isCustom = value === '기타'

    this.customFieldTarget.classList.toggle('hidden', !isCustom)

    if (!isCustom) {
      this.customInputTarget.value = ''
    }
  }

  // 폼 제출 시: 기타 입력값을 product_use 필드에 설정
  submit() {
    if (this.selectInputTarget.value === '기타') {
      const customValue = this.customInputTarget.value.trim()
      if (customValue) {
        this.selectInputTarget.value = `기타: ${customValue}`
      }
    }
  }
}
